import React, { useState, useEffect } from "react";
import HeatmapTable, { hexToStatus } from "../heatmap/HeatmapTable";
import Loading from "../../../../common-components/Loading";
import { getL2HeatmapCurrentYearAPI } from "../../../../api/reports-api";

const COLS = [
  {
    key: "contractRevActFc",
    label: "Revenue\nActuals + Forecast",
    w: 165,
    isCurrency: true,
  },
  {
    key: "contractRevBudget",
    label: "Revenue\nBudget",
    w: 155,
    isCurrency: true,
  },
  {
    key: "gmActFc",
    label: "Gross Margin\nActuals + Forecast",
    w: 155,
    isCurrency: true,
  },
  { key: "gmBudget", label: "Gross Margin\nBudget", w: 145, isCurrency: true },
  { key: "vacantFTEs", label: "Vacant FTEs", w: 90, isCurrency: false },
];

function mapRow(r) {
  return {
    id: r.clin,
    projectName: r.projectName,
    pm: r.programManager,
    contractRevActFc: r.contractRevenue,
    contractRevBudget: r.contractRevenueBudget,
    gmActFc: r.grossMargin,
    gmBudget: r.grossMarginBudget,
    vacantFTEs: r.vacantFte,
    financial: hexToStatus(r.financial),
    performer: hexToStatus(r.perform),
    funding: hexToStatus(r.funding),
    staffing: hexToStatus(r.staffing),
    culture: hexToStatus(r.culture),
    customer: hexToStatus(r.customer),
    doge: hexToStatus(r.doge),
  };
}

function mapTotal(t) {
  return {
    contractRevActFc: t.contractRevenue,
    contractRevBudget: t.contractRevenueBudget,
    gmActFc: t.grossMargin,
    gmBudget: t.grossMarginBudget,
    vacantFTEs: t.vacantFte,
    financial: null,
    performer: null,
    funding: null,
    staffing: null,
    culture: null,
    customer: null,
    doge: null,
  };
}

export default function CurrentYearHeatmap({ filters, onMeta }) {
  const programManager = filters?.programManager || [];
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [totalRow, setTotalRow] = useState(null);
  const [title, setTitle] = useState("Current Year Heatmap");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getL2HeatmapCurrentYearAPI({ year: filters?.year, programManager })
      .then((res) => {
        if (cancelled) return;
        const d = res?.data;
        if (d) {
          setRows((d.rows || []).map(mapRow));
          setTotalRow(mapTotal(d.totals || {}));
          setTitle(`Current Year Heatmap — FY${d.fiscalYear}`);
          onMeta?.({
            actualThroughMonth: d.actualThroughMonth,
            fiscalYear: d.fiscalYear,
          });
        }
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [JSON.stringify(filters), programManager]);

  if (loading) return <Loading />;
  return (
    <HeatmapTable title={title} cols={COLS} totalRow={totalRow} rows={rows} />
  );
}
